module.exports = __webpack_public_path__ + "static/img/cambio.975e43c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cambio.png
// module id = tJ+h
// module chunks = 1